import apiClient from './api';

async function fetchOtherRequests(params) {
  try {
    const response = await apiClient.get('/get-other-requests', {
      params // 👈 this is the key fix
    });
    return response;
  } catch (error) {
    console.error('Error fetching other requests:', error);
    throw error;
  }
}



async function createOrUpdateOtherRequest(data) {
  try {
    console.log(data)
    const response = await apiClient.post('/create-other-request', data);
    return response;
  } catch (error) {
    console.error('Error creating other request:', error);
    throw error;
  }
}

async function deleteOtherRequest(data) {
  try {
    const response = await apiClient.post('/delete-other-request', data);
    return response;
  } catch (error) {
    console.error('Error deleting other request:', error);
    throw error;
  }
}
async function accept(data) {
  try {
    const response = await apiClient.post('/review-other-request', {
      ...data,
      approved: 1
    });
    return response;
  } catch (error) {
    console.error('Error accepting other request:', error);
    throw error;
  }
}

async function reject(data) {
  try {
    const response = await apiClient.post('/review-other-request', {
      ...data,
      approved: 0
    });
    return response;
  } catch (error) {
    console.error('Error rejecting other request:', error);
    throw error;
  }
}

async function multaccept(data) {
  try {
    const response = await apiClient.post('/multiple-other-requests-accept', {
      ...data,
      approved: 1
    });
    return response;
  } catch (error) {
    console.error('Error accepting other requests:', error);
    throw error;
  }
}

async function multreject(data) {
  try {
    const response = await apiClient.post('/multiple-other-requests-reject', {
      ...data,
      approved: 0
    });
    return response;
  } catch (error) {
    console.error('Error rejecting other requests:', error);
    throw error;
  }
}
export { fetchOtherRequests, createOrUpdateOtherRequest, deleteOtherRequest, accept, reject, multaccept, multreject,};
